import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash-es/isEmpty'

import { EMPTY_LIST } from '../../../constants/common'
import { useInlineNotifications, useUkTimeZone } from '../../../hooks'
import { clearEmptyFields } from '../../../utils/formHelpers'
import { parseServerValidation } from '../../../utils/validation'
import {
  createAddress,
  getCreateAddressPayloadFromSelectValue,
} from '../../Address'
import { FormikForm } from '../../Formik'
import { createBuilding } from '../Building.api'

import {
  BUILDING_FORM_FIELD_NAME_ADDRESS,
  BUILDING_FORM_FIELD_NAME_BUILDING_NUMBER,
  BUILDING_FORM_INITIAL_VALUES,
} from './BuildingForm.constants'
import {
  getBuildingFormCreationPayload,
  getBuildingFormValidationSchema,
} from './BuildingForm.utils'
import { BuildingFormFields } from './BuildingFormFields'

function BuildingForm({
  FormContainer,
  containerProps,
  getCreationPayload = getBuildingFormCreationPayload,
  initialValues = BUILDING_FORM_INITIAL_VALUES,
  setModal,
  onCancel,
  onError,
  onSuccess,
  ...restProps
}) {
  const { t } = useTranslation()

  const [files, setFiles] = useState(EMPTY_LIST)

  const { timezone } = useUkTimeZone()

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const validationSchema = getBuildingFormValidationSchema()

  function handleSubmit(values, { setErrors, setSubmitting }) {
    const payload = getCreationPayload({
      files,
      timezone,
      values,
    })

    createAddress(
      getCreateAddressPayloadFromSelectValue(
        values[BUILDING_FORM_FIELD_NAME_ADDRESS]
      )
    )
      .then(({ data }) => {
        createBuilding(
          clearEmptyFields({
            ...payload,
            [BUILDING_FORM_FIELD_NAME_ADDRESS]: data.id,
          })
        )
          .then(({ data }) => {
            onSuccess?.({
              address:
                values[BUILDING_FORM_FIELD_NAME_ADDRESS].label ||
                values[BUILDING_FORM_FIELD_NAME_ADDRESS],
              id: data.id,
              objectNumber: values[BUILDING_FORM_FIELD_NAME_BUILDING_NUMBER],
            })
          })
          .catch(({ response }) => {
            setSubmitting(false)

            if (isEmpty(response?.data)) {
              onError?.()
            } else {
              setErrors(parseServerValidation(response?.data))
            }
          })
      })
      .catch(() => {
        setSubmitting(false)

        setErrors({
          [BUILDING_FORM_FIELD_NAME_ADDRESS]: t(
            'Error.BuildingAddressCreationFailedKey'
          ),
        })
      })
  }

  return (
    <FormikForm
      Container={FormContainer}
      containerProps={containerProps}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <BuildingFormFields
        {...restProps}
        files={files}
        notifications={notifications}
        setFiles={setFiles}
        setModal={setModal}
        onCancel={onCancel}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default BuildingForm
